export default "__VITE_ASSET__BYBwBsSG__"